import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

export default function AdminLogin() {
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState(null);
     const [loading, setLoading] = useState(false);
     const { signIn } = useAuth();
     const navigate = useNavigate();

     async function handleSubmit(e) {
          e.preventDefault();
          setError(null);
          setLoading(true);

          const { error } = await signIn(email, password);
          if (error) {
               setError(error.message);
               setLoading(false);
          } else {
               navigate('/admin');
          }
     }

     const inputClasses =
          'w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-darker placeholder-darker/30 focus:outline-none focus:border-yellow duration-300';

     return (
          <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
               <div className='w-full max-w-md mx-4'>
                    <div className='text-center mb-8'>
                         <h1 className='text-yellow text-sm uppercase tracking-wider'>
                              Ripout Rentals
                         </h1>
                         <h2 className='text-darker text-3xl mt-2'>Admin Login</h2>
                    </div>

                    <form
                         onSubmit={handleSubmit}
                         className='bg-white rounded-xl p-6 border border-gray-200 space-y-4'
                    >
                         {error && (
                              <div className='bg-red-50 border border-red-200 rounded-lg p-3 text-red-700 text-sm'>
                                   {error}
                              </div>
                         )}

                         <div>
                              <label className='block text-darker/60 text-sm mb-1'>
                                   Email
                              </label>
                              <input
                                   type='email'
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   placeholder='admin@ripoutrentals.com'
                                   className={inputClasses}
                                   required
                              />
                         </div>

                         <div>
                              <label className='block text-darker/60 text-sm mb-1'>
                                   Password
                              </label>
                              <input
                                   type='password'
                                   value={password}
                                   onChange={(e) => setPassword(e.target.value)}
                                   placeholder='••••••••'
                                   className={inputClasses}
                                   required
                              />
                         </div>

                         <button
                              type='submit'
                              disabled={loading}
                              className='w-full font-semibold text-lg rounded-xl border border-yellow text-darker py-3 hover:bg-yellow/10 duration-300 disabled:opacity-50'
                         >
                              {loading ? 'Signing in...' : 'Sign In'}
                         </button>
                    </form>
               </div>
          </div>
     );
}
